export default __webpack_public_path__ + "static/apple-icon-180x180-ddfde3e5e820b458a4a717ccab529821.png";